import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentMethodExceptionLimit } from '@/models/ps-management/exception-limit.model';

export default
class GetPaymentMethodExceptionLimitListRequest extends ApiResourceMethod<PaymentMethodExceptionLimit[]> {
  public perform(methodId: string): Promise<PaymentMethodExceptionLimit[]> {
    return this.performer.requestWithMapper(
      { url: `paymentMethodSettings/${methodId}/extendedLimit` },
      (payload: BaseResponse<PaymentMethodExceptionLimit[]>): PaymentMethodExceptionLimit[] => {
        return payload.data;
      },
    );
  }
}
